__turbopack_context__.v({
  "btns": "estimation-form-module__4OaBSa__btns",
  "form": "estimation-form-module__4OaBSa__form",
  "loading": "estimation-form-module__4OaBSa__loading",
  "next": "estimation-form-module__4OaBSa__next",
  "step": "estimation-form-module__4OaBSa__step",
  "tabs": "estimation-form-module__4OaBSa__tabs",
  "wrapper": "estimation-form-module__4OaBSa__wrapper",
});
